<template>
  <div class="pricing-list-item">
    <template v-if="productType">
      <div
        :class="[
          'pricing-list-item__wrapper',
          isPromotionalProduct && 'pricing-list-item__wrapper--promotional-subscription',
          isLiveVirtualTrainingItem && 'pricing-list-item__wrapper--live-virtual-training',
          isSkillDiveItem && 'pricing-list-item__wrapper--skill-dive',
          isBooGoItem && 'pricing-list-item__wrapper--boogo',
        ]"
      >
        <button
          @click="removeItemShoppingCart(product)"
          class="btn btn--small btn--tertiary btn--training pricing-list-item__btn"
        />
        <p
          v-if="!isSkillDiveItem"
          :class="[
            'pricing-list-item__selected-name',
            isBooGoItem && 'pricing-list-item__selected-name--boogo',
          ]"
        >
          <template v-if="isPromotionalProduct">
            {{ promoProductName }}
          </template>
          <template v-else-if="isBooGoItem">
            <div class="pricing-list-item__boogo">
              <div class="pricing-list-item__boogo-item">Premium</div>
              <div alt="Premium BooGo" class="pricing-list-item__boogo-icon" />
            </div>
          </template>
          <template v-else>
            {{ productName }}
          </template>
        </p>
        <div
          v-if="isSkillDiveItem"
          class="pricing-list-item__selected-name pricing-list-item__selected-name--skill-dive"
        >
          <img
            :src="skillDiveLogoBadge"
            alt="Skill Dive Experience"
            class="pricing-list-item__skill-dive-icon"
          />
          <div class="pricing-list-item__skill-dive-add-ons">
            {{ skillDiveSelectedAddOns }}
          </div>
        </div>
        <p
          v-if="isBooGoItem"
          class="pricing-list-item__selected-price pricing-list-item__selected-price--mt-5 pricing-list-item__selected-price--no-wrap"
        >
          <span>{{ `${currencySymbol}${productPrice}` }}</span>
          <span>{{ ' /2 years' }}</span>
        </p>
        <p v-else class="pricing-list-item__selected-price">
          {{ `${currencySymbol}${productPrice}` }}
        </p>
      </div>
      <div v-if="isPromotionalProduct" class="pricing-list-item__promo-warning">
        <template v-if="isEJPTPromoSubscription">
          <Pill info class="pricing-list-item__selected-name-pill">
            <span class="pricing-list-item__selected-name-pill-text--hide-mobile">
              +3 months of Fundamentals*
            </span>
            <span class="pricing-list-item__selected-name-pill-text--hide-desktop">
              +3 mo of Fundamentals*
            </span>
          </Pill>
          <p>
            *eJPT + three months of training includes three months of Fundamentals subscription.
            After the initial three months, Subscribers will be upgraded to the Premium subscription
            at a one-time, discounted rate of $350.00 (over $200.00 off) for the following nine
            month period unless canceled prior to renewal.
          </p>
        </template>
        <template v-if="isPlusThreeSubscription">
          <Pill info class="pricing-list-item__selected-name-pill"> + 3 months of Premium* </Pill>
          <p>
            *After 3 months, you'll be billed $350 for 9 more months of Premium. Your subscription
            renews annually at $749.
          </p>
        </template>
        <p v-if="!isLiveVirtualTrainingItem">
          You can cancel your subscription at any time before the
          {{ `${isEJPTPromoSubscription || isPlusThreeSubscription ? '3 months Free' : ''}` }}
          period ends in your profile settings.
        </p>
      </div>
      <div
        :class="[
          'pricing-list-item__verbage',
          isSkillDiveItem && 'pricing-list-item__verbage--skill-dive',
        ]"
        v-if="!isLiveVirtualTrainingItem"
      >
        <div class="pricing-list-item__verbage-border" v-if="!isPremiumPlusSubscription"></div>
        <p></p>
        <p v-if="isBooGoItem" class="pricing-list-item__verbage-text">
          Your INE subscription will automatically renew at standard stated pricing at end of each
          subscription term unless you cancel your renewal prior to the end of said term. You must
          cancel your subscription renewal before the scheduled renewal date to avoid auto renewal
          and the associated renewal fee.
        </p>
        <p v-else-if="isLVTItem" class="pricing-list-item__verbage-text">
          Registrants may cancel up to 14 days before the scheduled training date for a 50% refund.
          No refunds will be issued for cancellations made less than 13 days before the training
          date. Registrants may not transfer their registration to another individual or reschedule
          for a future session. INE reserves the right to cancel or reschedule sessions due to low
          enrollment or unforeseen circumstances, in which case registrants will receive a full
          refund or the option to reschedule.
        </p>
        <p v-else-if="isEJPTPromoSubscription" class="pricing-list-item__verbage-text">
          Your INE Subscription will automatically renew at the end of each subscription term unless
          you cancel before your renewal date. You must cancel your subscription renewal before the
          scheduled renewal date to avoid the automatic renewal and any renewal fees associated with
          your subscription.
        </p>
        <PricingListSubAndSkillDive
          v-else-if="isPremiumPlusSubscription"
          :product="product"
          :skillDivePlan="skillDivePlan"
        />
        <p v-else class="pricing-list-item__verbage-text">
          Your INE Subscription renews automatically unless canceled before the renewal date. To
          avoid charges, cancel before the scheduled renewal.
          <template v-if="isPremiumSubscriptionItem">
            Your 50% off exam redemption code will be delivered via email within 1 hour of
            completing your purchase.
          </template>
          <template v-if="isFundamentalsAnnualItem">
            Your voucher redemption codes for the eJPT and ICCA exams will be delivered via email
            within 1 hour of completing your purchase.
          </template>
        </p>
      </div>
    </template>
    <div v-else class="pricing-list-item__wrapper">
      <button
        @click="removeItemShoppingCart(product)"
        class="btn btn--small btn--tertiary btn--training pricing-list-item__btn"
      />
      <p class="pricing-list-item__selected-name">{{ productName }}</p>
      <p class="pricing-list-item__selected-price">
        <span>{{ currencySymbol }}</span>
        <span>{{ productPrice }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { updateCart } from '@/helpers/mixins'
import CONSTANTS from '@/constants'
import Pill from '@/components/shared/Pill.vue'
import skillDiveLogo from '@/assets/images/hero-section/skill-dive/skill-dive-logo.png'
import boogoLogo from '@/assets/images/hero-section/boogo/boogo_card_title.svg'
import PricingListSubAndSkillDive from './PricingListSubAndSkillDive.vue'

const { PLANS, LIVE_VIRTUAL_TRAININGS } = CONSTANTS

const { CCIE_SECURITY_V6, LVT_CHATGPT_AND_IA } = LIVE_VIRTUAL_TRAININGS
const {
  MONTHLY_EJPT,
  EJPT_FUNDAMENTALS,
  EDA_PREMIUM,
  SKILL_DIVE_ANNUAL,
  INE_PREMIUM_BOOGO_2Y,
  ECPPT_PREMIUM,
  EWPTX_PREMIUM,
  EWPT_PREMIUM,
  ANNUAL,
  PREMIUM,
} = PLANS

export default {
  name: 'PricingListItem',
  mixins: [updateCart],
  components: {
    Pill,
    PricingListSubAndSkillDive,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      skillDiveLogoBadge: skillDiveLogo,
      boogoLogoBadge: boogoLogo,
      isBooGoItem: this.product?.merchant_id === INE_PREMIUM_BOOGO_2Y,
    }
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      availableLiveVirtualTrainings: state => state.products.availableLiveVirtualTrainings,
    }),
    ...mapGetters({
      isBusinessUser: 'business/isBusinessUser',
      shoppingCart: 'shoppingCart/getShoppingCart',
      planCodes: 'products/getPlanCodes',
      currencySymbol: 'priceDetails/getCurrencySymbol',
    }),
    productType() {
      const code = this.product?.merchant_id ?? ''
      const liveVirtualTrainingsCodes = Object.values(LIVE_VIRTUAL_TRAININGS)
      // if true, is subscription
      return [...this.planCodes, ...liveVirtualTrainingsCodes].includes(code)
    },
    isPromotionalProduct() {
      const code = this.product?.merchant_id ?? ''
      return [
        MONTHLY_EJPT,
        EJPT_FUNDAMENTALS,
        EDA_PREMIUM,
        CCIE_SECURITY_V6,
        LVT_CHATGPT_AND_IA,
        ECPPT_PREMIUM,
        EWPTX_PREMIUM,
        EWPT_PREMIUM,
      ].includes(code)
    },
    isEJPTPromoSubscription() {
      const code = this.product?.merchant_id ?? ''
      return [MONTHLY_EJPT, EJPT_FUNDAMENTALS].includes(code)
    },
    isPlusThreeSubscription() {
      const code = this.product?.merchant_id ?? ''
      return [EDA_PREMIUM, ECPPT_PREMIUM, EWPT_PREMIUM, EWPTX_PREMIUM].includes(code)
    },
    isPremiumSubscriptionItem() {
      const code = this.product?.merchant_id ?? ''
      return PREMIUM === code
    },
    isFundamentalsAnnualItem() {
      const code = this.product?.merchant_id ?? ''
      return ANNUAL === code
    },
    isLiveVirtualTrainingItem() {
      const code = this.product?.merchant_id ?? ''
      return [CCIE_SECURITY_V6, LVT_CHATGPT_AND_IA].includes(code)
    },
    isSkillDiveItem() {
      return this.product.merchant_id === SKILL_DIVE_ANNUAL
    },
    isLVTItem() {
      const codes = this.availableLiveVirtualTrainings.map(p => p.merchant_id)
      return codes.includes(this.product.merchant_id)
    },
    skillDiveSelectedAddOns() {
      return this.isSkillDiveItem
        ? this.product.addOnsOnCart.map(SDAddOn => SDAddOn.label).join(', ')
        : false
    },
    promoProductName() {
      return this.product.nameToShow ?? this.product?.name
    },
    productName() {
      const name = this.product?.name ?? ''
      return name.replace('INE', '')
    },
    productPrice() {
      let price = this.product?.user_receives_discount
        ? this.product?.discounted_price_cents ?? 0
        : this.product?.price_cents ?? 0

      if (this.product?.addOnsOnCart?.length) {
        this.product.addOnsOnCart.forEach(addOn => {
          price += addOn.user_receives_discount ? addOn.discounted_price_cents : addOn.price_cents
        })
      }

      price = price % 100 === 0 ? price / 100 : (price / 100).toFixed(2)
      return price.toString()
    },
    isPremiumPlusSubscription() {
      return this.product?.merchant_id === PLANS.PREMIUM_PLUS
    },
  },
  methods: {
    ...mapActions({
      removeProductFromCart: 'shoppingCart/removeProductFromShoppingCart',
    }),
    removeItemShoppingCart(item) {
      if (this.isSkillDiveItem) {
        this.gaRemoveFromCartEvent(
          this.product,
          Object.assign({}, this.$store, { rootState: this.fullState })
        )
        this.clearSkillDiveItemsFromCart(item)
      }
      const exists = this.shoppingCart.find(i => i.id === item.id)
      if (exists) {
        this.removeProductFromCart(exists)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pricing-list-item {
  $this: &;
  border: 1px solid var(--tundora-gray);
  border-radius: 10px;
  padding: 15px;
  &__wrapper {
    display: grid;
    grid-template-columns: 40px auto 75px;
    align-items: flex-start;
    width: 100%;
    color: var(--white);
    font-size: rem(16);
    line-height: 23px;
    display: flex;
    align-items: center;
    &--promotional-subscription {
      height: unset;
    }
    &--live-virtual-training {
      align-items: center;
    }
    &--skill-dive {
      height: unset;
    }
    &--boogo {
      height: 40px;
      grid-template-columns: 40px auto 110px;
    }
  }
  &__btn {
    border: none;
    margin: 0;
    cursor: pointer;
    align-self: baseline;
    /* file name: '@/assets/icons/garbage_icon.svg' */
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='22' viewBox='0 0 20 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 2C7.44772 2 7 2.44772 7 3V4H13V3C13 2.44772 12.5523 2 12 2H8ZM15 4V3C15 1.34315 13.6569 0 12 0H8C6.34315 0 5 1.34315 5 3V4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H2V19C2 20.6569 3.34315 22 5 22H15C16.6569 22 18 20.6569 18 19V6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H15ZM4 6V19C4 19.5523 4.44772 20 5 20H15C15.5523 20 16 19.5523 16 19V6H4ZM8 9C8.55228 9 9 9.44771 9 10V16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16V10C7 9.44771 7.44772 9 8 9ZM12 9C12.5523 9 13 9.44771 13 10V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V10C11 9.44771 11.4477 9 12 9Z' fill='white'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
  }
  &__selected-name {
    margin: 0 auto 0 10px;
    text-align: left;
    width: 100%;
    @include mobile {
      margin: 0 auto 0 10px;
    }
    &--skill-dive {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      flex-flow: column;
      align-items: flex-start;
      @include desktop {
        flex-flow: row;
        align-items: center;
      }
    }
    &--boogo {
      position: relative;
    }
    #{$this} {
      &__skill-dive {
        &-icon {
          width: 100px;
          height: 26px;
          @include mobile {
            width: 130px;
          }
        }
      }
    }
    &-pill {
      margin: 10px 0;
      font-size: rem(10px);
      line-height: 12px;
      @include desktop {
        font-size: rem(12px);
        line-height: 14px;
      }
      &--live-virtual-training {
        margin: 0;
      }
      &-text {
        &--hide {
          &-mobile {
            display: none;
            @include desktop {
              display: block;
            }
          }
          &-desktop {
            display: block;
            @include desktop {
              display: none;
            }
          }
        }
      }
    }
  }
  &__selected-price {
    font-size: rem(18);
    line-height: 24px;
    text-align: right;
    margin: 0;
    &--mt-5 {
      margin-top: 5px;
    }
    &--no-wrap {
      @include tablet-ipad-pro {
        white-space: nowrap;
      }
      @include desktop {
        white-space: nowrap;
      }
      span:nth-of-type(2) {
        white-space: nowrap;
      }
    }
  }
  &__promo-warning {
    margin: 5px 0 0 50px;
    color: var(--dusty-gray);
    font-size: rem(12);
    line-height: 14px;
    text-align: left;
    display: grid;
    gap: 5px;
    @include tablet {
      display: block;
      gap: unset;
      margin: 0 0 0 50px;
    }
    p {
      margin-top: 0;
      margin-bottom: 10px;
    }
  }
  &__voucher-wrapper {
    @include tablet {
      padding: 0 20px;
    }
  }
  &__voucher {
    max-height: 42px;
    background: rgba(64, 252, 196, 0.12);
    border: 1px solid #00da99;
    border-radius: 10px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 22px;
    @include tablet {
      max-height: 62px;
      padding: 20px;
      font-size: 18px;
    }
    &--price {
      text-transform: uppercase;
      margin: 0 0 0 25px;
    }
  }
  &__verbage {
    color: var(--dusty-gray);
    font-size: rem(12);
    line-height: 14px;
    text-align: left;
    margin: 0;
    @include mobile {
      margin: 0 0 15px 20px;
    }
    display: flex;
    &-border {
      height: auto;
      width: 3px;
      border-left: 3px solid var(--white);
      border-radius: 10px;
    }
    &-text {
      margin: 0 0 0 10px;
    }
    &--skill-dive {
      margin-top: 15px !important;
    }
  }
  &__boogo {
    display: flex;
    &-item {
      display: flex;
      align-items: center;
    }
    &-icon {
      height: 35px;
      width: 50px;
      background-image: url('data:image/svg+xml,<svg width="74" height="51" viewBox="0 0 74 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.288259 38.9397C0.288259 41.0837 2.62426 41.4997 2.62426 41.4997V50.0437L2.84826 49.8197C3.68026 49.1797 4.32026 40.4437 4.76826 39.8037C5.18426 38.9397 6.24026 38.9397 7.10426 38.5237C10.7203 36.7957 12.6403 33.8197 12.6403 29.9797C12.6403 28.6997 11.8083 27.1957 10.9443 26.3637C10.3043 25.7237 7.10426 22.5237 6.46426 21.8837C6.46426 21.8837 6.46426 21.8837 6.46426 21.6597C6.46426 21.6597 11.5843 19.7397 11.5843 16.3157C11.5843 13.1157 2.84826 10.7797 2.84826 9.72374V0.123737C2.40026 0.123737 2.20826 0.763737 2.20826 0.955738C1.98426 2.23574 1.12026 7.99574 0.928259 9.27574C0.928259 9.49974 0.704259 11.0037 0.704259 11.1957C0.704259 12.2837 0.704259 16.7637 0.704259 17.5957C0.704259 21.6597 0.928259 25.7237 0.928259 29.5637C0.928259 32.7637 0.288259 35.7397 0.288259 38.9397ZM4.76826 37.4357C4.12826 33.1797 4.32026 28.6997 4.32026 24.4437C4.32026 24.2197 4.32026 23.9957 4.76826 23.9957C7.74426 23.9957 10.3043 28.4757 10.3043 31.0357C10.3043 34.0437 7.96826 36.3797 5.40826 37.8837H5.18426C4.96026 37.8837 4.76826 37.8837 4.76826 37.4357ZM4.54426 19.7397C4.54426 19.5157 4.54426 18.8757 4.54426 18.6837C4.54426 17.8197 4.54426 14.2037 5.82426 14.2037C7.10426 14.2037 9.24826 15.2597 9.24826 16.7637C9.24826 18.6837 6.46426 19.9637 4.96026 19.9637C4.96026 19.9637 4.54426 19.9637 4.54426 19.7397ZM14.6008 32.1237C14.6008 37.8837 16.5208 45.7557 23.5608 45.7557C29.0968 45.7557 29.5128 34.6837 29.5128 31.2597C29.5128 26.7797 29.5128 16.5397 22.6968 16.5397C21.4168 16.5397 21.0008 18.0437 19.9128 18.4597L19.4968 18.6837C16.0728 21.4357 14.6008 28.0597 14.6008 32.1237ZM18.2168 31.8997C18.2168 28.9237 19.0808 26.1397 19.0808 23.3557V22.9397C18.4408 23.3557 17.3528 25.0837 17.3528 25.2757V24.6357C17.3528 22.9397 18.4408 19.5157 20.3608 19.5157C20.3608 20.1557 19.9128 20.6037 19.9128 21.2437V21.4357C20.1368 21.2437 21.4168 19.9637 22.0568 19.9637C23.7528 19.7397 25.6728 27.8357 25.8968 28.6997C25.8968 29.1157 25.8968 31.0357 25.8968 31.2597C25.8968 33.4037 25.2568 42.7797 21.8328 42.7797C18.8568 42.7797 18.2168 33.8197 18.2168 31.8997ZM30.6008 33.5957C30.6008 38.2997 32.9368 43.1957 38.4728 43.1957C42.9528 43.1957 43.5928 35.5157 43.5928 32.5397C43.5928 28.6997 42.9528 21.6597 37.6408 21.6597C36.1368 21.6597 36.7768 22.9397 35.9128 23.3557C32.9368 24.8597 31.2408 27.8357 30.6008 31.2597C30.6008 31.6757 30.6008 33.1797 30.6008 33.5957ZM33.8008 32.9557C33.8008 31.4837 34.2168 24.8597 37.0008 24.8597C38.9208 24.8597 40.2008 31.2597 40.2008 32.5397C40.2008 34.4597 39.7528 40.2197 36.7768 40.2197C34.4408 40.2197 33.8008 34.4597 33.8008 32.9557ZM34.2168 25.9157C34.2168 26.1397 34.2168 26.5557 33.8008 26.5557C33.8008 26.3637 33.8008 25.9157 34.2168 25.9157ZM55.2365 47.8997C55.2365 48.7637 55.8765 49.4037 56.5165 49.4037C57.3805 49.4037 58.2445 48.9557 58.4365 48.1237C58.4365 47.8997 58.4365 46.3957 58.4365 45.9797C58.4365 41.7237 58.4365 38.5237 58.2445 33.4037C58.0205 31.4837 57.1565 23.3557 53.5405 23.3557C53.3165 23.3557 53.1245 23.3557 53.1245 23.8037C53.1245 23.8037 55.2365 26.1397 55.4605 27.0037C55.4605 29.3397 55.8765 31.4837 55.8765 33.8197C55.8765 35.5157 54.8205 37.8837 52.6765 37.8837C50.9805 37.8837 49.7005 33.1797 49.7005 32.1237C49.7005 31.4837 49.4765 28.6997 49.4765 28.0597C49.4765 27.8357 49.4765 25.9157 49.4765 25.0837C49.4765 23.3557 49.4765 14.2037 52.9005 14.2037C54.8205 14.2037 54.1805 17.8197 56.1005 17.8197C57.3805 17.8197 57.6045 16.5397 57.6045 15.4837C57.6045 13.1157 55.0445 11.0037 52.6765 11.0037C46.0845 11.0037 45.4445 21.6597 45.4445 26.1397C45.4445 30.8437 46.5005 40.2197 52.9005 40.2197C54.1805 40.2197 55.0445 39.1637 56.1005 39.1637L56.3245 39.5797C56.3245 39.8037 56.3245 41.0837 56.3245 41.2757C56.3245 43.6437 55.2365 45.7557 55.2365 47.8997ZM60.4445 30.3957C60.4445 35.3237 63.0045 39.9957 68.3165 39.9957C72.7965 39.9957 73.4365 32.3157 73.4365 29.3397C73.4365 25.4997 72.7965 18.4597 67.6765 18.4597C65.9805 18.4597 66.8445 19.7397 65.7565 20.1557C62.7805 21.4357 61.0845 25.0837 60.4445 28.2837C60.4445 28.4757 60.4445 29.9797 60.4445 30.3957ZM63.8365 29.5637C63.8365 28.0597 63.8365 21.8837 66.8445 21.8837C68.9565 21.8837 70.0445 27.8357 70.0445 29.3397C70.0445 32.1237 69.5965 35.3237 67.2605 37.0197H66.8445C64.0605 37.0197 63.8365 31.2597 63.8365 29.5637Z" fill="%23A793F6"/></svg>');
      background-repeat: no-repeat;
      background-size: 50px;
      position: absolute;
      top: -7px;
      left: 70px;
    }
  }
}
</style>
